export default __webpack_public_path__ + "static/media/wordpress.3e923055.svg";